function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'multireducer';
import { actions as searchActions } from '../redux/knsearch';
import { translate } from 'react-translate';
import { Button } from 'react-bootstrap';
import { VectorLayer, provideMapState } from 'react-openlayers';
import './SearchSource.scss';
import SearchResultComponent from './SearchResultComponent';

var mapDispatchToProps = function mapDispatchToProps(dispatch, _ref) {
  var multireducerKey = _ref.multireducerKey;
  return bindActionCreators(searchActions, dispatch, multireducerKey);
};

var mapStateToProps = function mapStateToProps(state, _ref2) {
  var multireducerKey = _ref2.multireducerKey;
  return {
    knsearch: state.searchSources[multireducerKey],
    results: state.searchSources[multireducerKey].articles,
    selected: state.searchSources[multireducerKey].selected
  };
};

export var SearchSource = function (_React$Component) {
  _inherits(SearchSource, _React$Component);

  function SearchSource() {
    var _temp, _this, _ret;

    _classCallCheck(this, SearchSource);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      currentQuery: ''
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  SearchSource.prototype.componentDidMount = function componentDidMount() {
    var _props = this.props,
        performQuery = _props.performQuery,
        query = _props.query,
        multireducerKey = _props.multireducerKey,
        mapCenter = _props.mapCenter,
        mapExtent = _props.mapExtent,
        mapZoom = _props.mapZoom,
        projCode = _props.projCode;

    if (query) {
      performQuery(query, multireducerKey, mapCenter, mapExtent, mapZoom, projCode);
    }
  };

  SearchSource.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var performQuery = nextProps.performQuery,
        clearSearch = nextProps.clearSearch,
        query = nextProps.query,
        multireducerKey = nextProps.multireducerKey,
        mapCenter = nextProps.mapCenter,
        mapExtent = nextProps.mapExtent,
        mapZoom = nextProps.mapZoom,
        projCode = nextProps.projCode;

    if (query && query !== this.props.query) {
      performQuery(query, multireducerKey, mapCenter, mapExtent, mapZoom, projCode);
    } else if (this.props.query && !query) {
      clearSearch();
    }
  };

  SearchSource.prototype.componentWillUnmount = function componentWillUnmount() {
    var clearSearch = this.props.clearSearch;
    clearSearch();
  };

  SearchSource.prototype.renderResults = function renderResults(result) {
    var _props2 = this.props,
        onResultSelected = _props2.onResultSelected,
        searchResult = _props2.searchResult,
        source = _props2.source;
    var SearchResult = searchResult || SearchResultComponent;
    return React.createElement(SearchResult, {
      key: result.id,
      source: source,
      result: result,
      onResultSelected: onResultSelected
    });
  };

  SearchSource.prototype.render = function render() {
    var _this2 = this;

    var _props3 = this.props,
        results = _props3.results,
        multireducerKey = _props3.multireducerKey,
        t = _props3.t,
        selectSource = _props3.selectSource,
        visible = _props3.visible,
        selected = _props3.selected,
        source = _props3.source,
        title = _props3.title;
    var sourceConfig = source.config;
    var numResults = Object.keys(results).length;
    if (!numResults) return null;
    return React.createElement('div', {
      className: 'searchSource--container source-' + source.dataIndex
    }, React.createElement(VectorLayer, {
      layerName: multireducerKey + '_search',
      features: visible && Object.values(results).map(function (result) {
        return result.olFeature;
      }),
      featureStyle: {
        fillColor: sourceConfig.fillColor,
        fillOpacity: sourceConfig.fillOpacity,
        fontColor: sourceConfig.fontColor,
        strokeColor: sourceConfig.borderColor,
        strokeOpacity: sourceConfig.strokeOpacity,
        strokeWidth: sourceConfig.strokeWidth,
        pointRadius: sourceConfig.pointRadius
      },
      clusterThreshold: 0,
      useActiveStyle: true,
      useHoverStyle: true
    }), React.createElement('h2', null, title, ' (', numResults, ')'), numResults > 5 && React.createElement(Button, {
      className: 'pull-right',
      bsStyle: 'link',
      title: t('showAllResults'),
      onClick: function onClick() {
        return selectSource();
      }
    }, selected ? t('goBack') : t('showAllResults')), React.createElement('ul', {
      className: numResults === 0 || !visible ? 'searchSource--noResults' : ''
    }, Object.values(results || {}).slice(0, selected ? numResults : 5).map(function (result) {
      return _this2.renderResults(result);
    })));
  };

  return SearchSource;
}(React.Component);
SearchSource.propTypes = process.env.NODE_ENV !== "production" ? {
  t: PropTypes.func,
  results: PropTypes.object,
  onResultSelected: PropTypes.func.isRequired,
  performQuery: PropTypes.func,
  selectSource: PropTypes.func,
  clearSearch: PropTypes.func,
  multireducerKey: PropTypes.string.isRequired,
  query: PropTypes.string.isRequired,
  visible: PropTypes.bool.isRequired,
  selected: PropTypes.bool,
  source: PropTypes.object.isRequired,
  mapCenter: PropTypes.any,
  mapZoom: PropTypes.number,
  mapExtent: PropTypes.array,
  projCode: PropTypes.string,
  title: PropTypes.string.isRequired,
  searchResult: PropTypes.func
} : {};
export default connect(mapStateToProps, mapDispatchToProps)(translate('SearchSource')(provideMapState(SearchSource)));